__turbopack_context__.v({
  "card": "ReviewsSkeleton-module-scss-module__VPKxKa__card",
  "cards": "ReviewsSkeleton-module-scss-module__VPKxKa__cards",
  "page": "ReviewsSkeleton-module-scss-module__VPKxKa__page",
  "second-card": "ReviewsSkeleton-module-scss-module__VPKxKa__second-card",
});
